import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, vModelText as _vModelText, withDirectives as _withDirectives, Fragment as _Fragment, renderList as _renderList, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = { class: "container sub_page _activity" }
const _hoisted_2 = { class: "sub_page_tit" }
const _hoisted_3 = {
  class: "sub_menu_tab wrap_1120",
  ref: "header"
}
const _hoisted_4 = { class: "sub_page_con wrap_1120" }
const _hoisted_5 = { class: "bread_crumbs" }
const _hoisted_6 = { class: "sub_page_con_view sign_form con_write" }
const _hoisted_7 = { class: "report_con" }
const _hoisted_8 = { class: "checkbox_wrap" }
const _hoisted_9 = { class: "date_wrap" }
const _hoisted_10 = { class: "date_wrap" }
const _hoisted_11 = { class: "" }
const _hoisted_12 = { class: "date_wrap" }
const _hoisted_13 = { class: "add_wrap" }
const _hoisted_14 = { class: "con_form" }
const _hoisted_15 = { class: "form_li_tit" }
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "file_wrap" }
const _hoisted_18 = { for: "area_file" }
const _hoisted_19 = { class: "file_list" }
const _hoisted_20 = ["onClick"]
const _hoisted_21 = ["onClick"]
const _hoisted_22 = { class: "file_name" }
const _hoisted_23 = ["onClick"]
const _hoisted_24 = { class: "btn_wrap _default left_right_btn _1_2" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_ModalDefault = _resolveComponent("ModalDefault")!
  const _component_ModalPreviewForBoard = _resolveComponent("ModalPreviewForBoard")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("section", _hoisted_2, [
        _cache[26] || (_cache[26] = _createStaticVNode("<div class=\"deco_wrap\"><i class=\"deco_01\"><img src=\"img/activity_left.png\"></i><i class=\"deco_02 _small blink4\"><img src=\"img/b_icon_01.png\"></i><i class=\"deco_03 _small blink_zoom1\"><img src=\"img/b_icon_02.png\"></i><i class=\"deco_04 _xxsmall blink_zoom4\"><img src=\"img/b_icon_05.png\"></i><i class=\"deco_05 none_768 spin2 _medium\"><img src=\"img/b_icon_03.png\"></i><i class=\"deco_06 none_768 spin_blink3 _small\"><img src=\"img/b_icon_01.png\"></i><i class=\"deco_07 none_768 blink_zoom4 _small\"><img src=\"img/b_icon_02.png\"></i><i class=\"deco_character\"><img src=\"img/activity_icon.png\"></i></div><div class=\"banner_wrap wrap_1120\"><h2>시민참여 활동</h2></div>", 2)),
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("button", {
            class: _normalizeClass(["only_768", { active: $setup.state.subMenuOpen }]),
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($setup.subMenuTab && $setup.subMenuTab(...args)))
          }, _toDisplayString($setup.state.subMenuName), 3),
          _createElementVNode("ul", {
            class: _normalizeClass({ active: $setup.state.subMenuOpen })
          }, [
            _createElementVNode("li", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => ($setup.changeTab(1))),
              class: _normalizeClass([$setup.state.tab === 1 ? 'active' : ''])
            }, [...(_cache[22] || (_cache[22] = [
              _createElementVNode("a", { href: "javascript:void(0)" }, "반성매매 시민활동", -1)
            ]))], 2),
            _createElementVNode("li", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => ($setup.changeTab(2))),
              class: _normalizeClass([$setup.state.tab === 2 ? 'active' : ''])
            }, [...(_cache[23] || (_cache[23] = [
              _createElementVNode("a", { href: "javascript:void(0)" }, "캠페인·이벤트", -1)
            ]))], 2),
            _createElementVNode("li", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => ($setup.changeTab(3))),
              class: _normalizeClass([$setup.state.tab === 3 ? 'active' : ''])
            }, [...(_cache[24] || (_cache[24] = [
              _createElementVNode("a", { href: "javascript:void(0)" }, "참여하고 싶은 반성매매 활동 제안", -1)
            ]))], 2),
            ($setup.user.isLogin())
              ? (_openBlock(), _createElementBlock("li", {
                  key: 0,
                  onClick: _cache[4] || (_cache[4] = ($event: any) => ($setup.changeTab(4))),
                  class: _normalizeClass([[$setup.state.tab === 4 ? 'active' : ''], "w_1024_custom_width"])
                }, [...(_cache[25] || (_cache[25] = [
                  _createElementVNode("a", { href: "javascript:void(0)" }, "액션 시민 활동", -1)
                ]))], 2))
              : _createCommentVNode("", true)
          ], 2)
        ], 512)
      ]),
      _createElementVNode("section", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "icon_wrap"
          }, {
            default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
              _createElementVNode("img", {
                src: "img/home_icon.png",
                alt: "홈"
              }, null, -1)
            ]))]),
            _: 1
          }),
          _cache[29] || (_cache[29] = _createElementVNode("span", { class: "icon_wrap" }, [
            _createElementVNode("img", {
              src: "img/part_icon.png",
              alt: "반성매매 시민활동"
            })
          ], -1)),
          _createVNode(_component_router_link, { to: { path: '/board', query: { type: 1 } } }, {
            default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
              _createTextVNode("반성매매 시민활동", -1)
            ]))]),
            _: 1
          }),
          _cache[30] || (_cache[30] = _createElementVNode("span", { class: "icon_wrap" }, [
            _createElementVNode("img", {
              src: "img/part_icon.png",
              alt: "글쓰기"
            })
          ], -1)),
          _cache[31] || (_cache[31] = _createElementVNode("span", { class: "faq_list_title" }, "글쓰기", -1))
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("ul", null, [
              _createElementVNode("li", _hoisted_8, [
                _cache[32] || (_cache[32] = _createElementVNode("span", { class: "form_li_tit" }, "제목", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  placeholder: "제목을 입력해주세요.",
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.form_state.title) = $event))
                }, null, 512), [
                  [_vModelText, $setup.form_state.title]
                ])
              ]),
              _createElementVNode("li", _hoisted_9, [
                _cache[33] || (_cache[33] = _createElementVNode("span", { class: "form_li_tit" }, "활동기간", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  placeholder: "",
                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.form_state.activityStartDate) = $event))
                }, null, 512), [
                  [_vModelText, $setup.form_state.activityStartDate]
                ]),
                _cache[34] || (_cache[34] = _createElementVNode("em", null, "~", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  placeholder: "",
                  "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (($setup.form_state.activityEndDate) = $event))
                }, null, 512), [
                  [_vModelText, $setup.form_state.activityEndDate]
                ])
              ]),
              _createElementVNode("li", _hoisted_10, [
                _cache[35] || (_cache[35] = _createElementVNode("span", { class: "form_li_tit" }, "모집기간", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  placeholder: "",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (($setup.form_state.recruitmentStartDate) = $event))
                }, null, 512), [
                  [_vModelText, $setup.form_state.recruitmentStartDate]
                ]),
                _cache[36] || (_cache[36] = _createElementVNode("em", null, "~", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  placeholder: "",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (($setup.form_state.recruitmentEndDate) = $event))
                }, null, 512), [
                  [_vModelText, $setup.form_state.recruitmentEndDate]
                ])
              ]),
              _createElementVNode("li", _hoisted_11, [
                _cache[37] || (_cache[37] = _createElementVNode("span", { class: "form_li_tit" }, "모집인원", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "text",
                  class: "w_100",
                  placeholder: "",
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => (($setup.form_state.cntMember) = $event))
                }, null, 512), [
                  [_vModelText, $setup.form_state.cntMember]
                ]),
                _cache[38] || (_cache[38] = _createTextVNode(" 명 ", -1))
              ]),
              _createElementVNode("li", _hoisted_12, [
                _cache[39] || (_cache[39] = _createElementVNode("span", { class: "form_li_tit" }, "신청 종료일", -1)),
                _withDirectives(_createElementVNode("input", {
                  type: "date",
                  placeholder: "",
                  "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => (($setup.form_state.endDate) = $event))
                }, null, 512), [
                  [_vModelText, $setup.form_state.endDate]
                ])
              ]),
              _createElementVNode("li", _hoisted_13, [
                _cache[40] || (_cache[40] = _createElementVNode("label", {
                  for: "area_address",
                  class: "form_li_tit"
                }, "주소", -1)),
                _withDirectives(_createElementVNode("input", {
                  id: "area_address",
                  readonly: "",
                  type: "text",
                  class: "code _blocked",
                  placeholder: "우편번호",
                  "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => (($setup.form_state.zipCode) = $event)),
                  onClick: _cache[13] || (_cache[13] = 
//@ts-ignore
(...args) => ($setup.searchAddress && $setup.searchAddress(...args)))
                }, null, 512), [
                  [_vModelText, $setup.form_state.zipCode]
                ]),
                _createElementVNode("button", {
                  class: "blue_btn w_120",
                  onClick: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => ($setup.searchAddress && $setup.searchAddress(...args)))
                }, "검색"),
                _withDirectives(_createElementVNode("input", {
                  id: "area_address",
                  readonly: "",
                  type: "text",
                  class: "text _blocked",
                  placeholder: "주소",
                  "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => (($setup.form_state.address) = $event))
                }, null, 512), [
                  [_vModelText, $setup.form_state.address]
                ]),
                _withDirectives(_createElementVNode("input", {
                  id: "area_address2",
                  type: "text",
                  placeholder: "상세주소",
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (($setup.form_state.addressDetail) = $event))
                }, null, 512), [
                  [_vModelText, $setup.form_state.addressDetail]
                ])
              ]),
              _cache[52] || (_cache[52] = _createElementVNode("li", { class: "con_form" }, [
                _createElementVNode("span", { class: "form_li_tit" }, "내용"),
                _createElementVNode("textarea", {
                  id: "editor1",
                  name: "editor1"
                })
              ], -1)),
              _createElementVNode("li", _hoisted_14, [
                _createElementVNode("span", _hoisted_15, [
                  _cache[41] || (_cache[41] = _createTextVNode(" 개인정보 수집 ", -1)),
                  (!$setup.state.isMobile)
                    ? (_openBlock(), _createElementBlock("br", _hoisted_16))
                    : _createCommentVNode("", true),
                  _cache[42] || (_cache[42] = _createTextVNode(" 및 이용 동의 ", -1))
                ]),
                _cache[43] || (_cache[43] = _createElementVNode("textarea", {
                  id: "editor2",
                  name: "editor2"
                }, null, -1))
              ]),
              _createElementVNode("li", _hoisted_17, [
                _cache[51] || (_cache[51] = _createElementVNode("span", { class: "form_li_tit" }, "첨부", -1)),
                _createElementVNode("label", _hoisted_18, [
                  _createElementVNode("input", {
                    id: "area_file",
                    type: "file",
                    placeholder: "",
                    accept: "image/*",
                    multiple: "",
                    onChange: _cache[17] || (_cache[17] = 
//@ts-ignore
(...args) => ($setup.handleFiles && $setup.handleFiles(...args)))
                  }, null, 32),
                  (!$setup.state.isMobile)
                    ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                        _cache[44] || (_cache[44] = _createElementVNode("div", { class: "file_box_wrap" }, "‘파일첨부’ 버튼을 클릭하여 첨부해주세요", -1)),
                        _cache[45] || (_cache[45] = _createElementVNode("span", {
                          class: "blue_btn",
                          style: {"display":"flex","justify-content":"center","align-items":"center"}
                        }, "파일첨부", -1)),
                        _cache[46] || (_cache[46] = _createElementVNode("p", { class: "p_info" }, "200M 이하 JPG, PNG 파일을 첨부해주세요.", -1))
                      ], 64))
                    : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                        _cache[47] || (_cache[47] = _createElementVNode("p", { class: "p_info" }, "200M 이하 JPG, PNG 파일을 첨부해주세요.", -1)),
                        _cache[48] || (_cache[48] = _createElementVNode("span", {
                          class: "blue_btn",
                          style: {"display":"flex","justify-content":"center","align-items":"center"}
                        }, "파일첨부", -1))
                      ], 64))
                ]),
                _createElementVNode("div", _hoisted_19, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.form_state.file, (item, idx) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "file",
                      key: idx
                    }, [
                      _createElementVNode("span", {
                        class: "file_name",
                        onClick: ($event: any) => ($setup.downloadFile(item.file, item.imgRealName))
                      }, _toDisplayString(item.imgRealName), 9, _hoisted_20),
                      _createElementVNode("button", {
                        class: "file_del icon_wrap",
                        onClick: ($event: any) => ($setup.fileRemove(item.idx))
                      }, [...(_cache[49] || (_cache[49] = [
                        _createElementVNode("img", {
                          src: "img/close_02.png",
                          alt: ""
                        }, null, -1)
                      ]))], 8, _hoisted_21)
                    ]))
                  }), 128)),
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($setup.state.file, (item, index) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "file",
                      key: index
                    }, [
                      _createElementVNode("span", _hoisted_22, _toDisplayString(item.name), 1),
                      _createElementVNode("button", {
                        class: "file_del icon_wrap",
                        onClick: ($event: any) => ($setup.removeNewFile(index))
                      }, [...(_cache[50] || (_cache[50] = [
                        _createElementVNode("img", {
                          src: "img/close_02.png",
                          alt: ""
                        }, null, -1)
                      ]))], 8, _hoisted_23)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_24, [
          _createElementVNode("button", {
            class: "common_btn _gray w_130",
            onClick: _cache[18] || (_cache[18] = ($event: any) => ($setup.router.go(-1)))
          }, "취소"),
          (!$setup.state.isMobile)
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: "common_btn w_130",
                onClick: _cache[19] || (_cache[19] = ($event: any) => ($setup.state.isShowPreview = true))
              }, "미리보기"))
            : _createCommentVNode("", true),
          _createElementVNode("button", {
            class: "common_btn w_130",
            onClick: _cache[20] || (_cache[20] = 
//@ts-ignore
(...args) => ($setup.save && $setup.save(...args)))
          }, "작성완료")
        ])
      ])
    ]),
    ($setup.state.isShowModal)
      ? (_openBlock(), _createBlock(_component_ModalDefault, {
          key: 0,
          type: $setup.state.modalTab,
          title: $setup.state.modalTitle,
          content: $setup.state.modalContent,
          onClose: $setup.closeModal,
          onCallback: $setup.callBackModal
        }, null, 8, ["type", "title", "content", "onClose", "onCallback"]))
      : _createCommentVNode("", true),
    ($setup.state.isShowPreview)
      ? (_openBlock(), _createBlock(_component_ModalPreviewForBoard, {
          key: 1,
          type: 'activity',
          header: $setup.header.innerHTML,
          title: $setup.form_state.title,
          content: $setup.form_state.content,
          data: $setup.form_state,
          onClose: _cache[21] || (_cache[21] = ($event: any) => ($setup.state.isShowPreview = false))
        }, null, 8, ["header", "title", "content", "data"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Footer)
  ], 64))
}